import React, { useState } from "react";
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber } from "libphonenumber-js";
import "react-phone-number-input/style.css";
import "./index.css"

const PhoneNumberInput = ({
    name,
    value,
    onChange,
    required = false,
    label,
    className = "",
    error: externalError,
}) => {
    const [localError, setLocalError] = useState(null);

    const handlePhoneChange = (phoneValue) => {
        // Emit a synthetic event to match your `handleCustomFieldChange`
        console.log(phoneValue, "Phone value")
        const syntheticEvent = {
            target: {
                name,
                value: phoneValue,
                type: "text", // for compatibility
            },
        };

        onChange(syntheticEvent); // Pass to handler

        if (required && (!phoneValue || !isValidPhoneNumber(phoneValue))) {
            setLocalError("Invalid phone number");
        } else {
            setLocalError(null);
        }
    };

    return (
        <div className="phone-input-container no-country-select">
            {label && <div>{label}</div>}
            <PhoneInput
                defaultCountry="NP"
                value={value}
                onChange={handlePhoneChange}
                international
                countryCallingCodeEditable={false}
                placeholder="Enter phone number"
                className={className}
            />
            {(localError || externalError) && (
                <span style={{ color: "red", fontSize: "0.875rem" }}>
                    {localError || externalError}
                </span>
            )}
        </div>
    );
};

export default PhoneNumberInput;
